import React from "react";

const Gender = ({ setGender, gender }) => {
  return (
    <React.Fragment>
      <h6 className="text-fw-bold text-center mb-3_5 line-height-2">
        性別を教えてください
      </h6>
      <p className="p-0 text-fz-small text-center">
        *後で変更できないので正確にご入力ください。
      </p>
      <div className="" style={{ paddingTop: "30px", paddingBottom: "180px" }}>
        <ul className="nav flex-column">
          <li className="nav-item p-3 border-bottom">
            <input
              name="options"
              type="radio"
              className="d-none checkbox__input checkbox__area"
              id="gender_male"
              onChange={(e) => setGender(e.target.value)}
              value="male"
              checked={gender === "male"}
            />
            <label
              className="d-flex justify-content-between align-items-center mb-0 position-relative"
              htmlFor="gender_male"
            >
              <span className="p-0 line-height-2 pl-3 mb-0">男性</span>
              <span className="checkbox__lg checkbox__noborder" />
            </label>
          </li>
          <li className="nav-item p-3 border-bottom">
            <input
              name="options"
              type="radio"
              className="d-none checkbox__input checkbox__area"
              id="gender_female"
              onChange={(e) => setGender(e.target.value)}
              value="female"
              checked={gender === "female"}
            />
            <label
              className="d-flex justify-content-between align-items-center mb-0 position-relative"
              htmlFor="gender_female"
            >
              <span className="p-0 line-height-2 pl-3 mb-0">女性</span>
              <span className="checkbox__lg checkbox__noborder" />
            </label>
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
};

export default Gender;
